import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // [!code ++]
import { Button, DescriptionBar, Grid, SearchBar } from 'components';
import { groundStationGridColumns } from './utils';
import { PlusOutlineIcon } from 'assets/svgs';
import RegisterModal from './RegisterModal';
import { GroundStaionDetailData, GroundStaionGridData } from './types';
import GroundStationModal from './GroundStationModal';
import { cloneDeep } from 'lodash-es';
import { fetchGroundStationList, fetchGroundStationDetail } from 'api/groundStation';

const ManageGroundStation = () => {
  const { t } = useTranslation(); // [!code ++]
  const [isRegisterModalOpened, setIsRegisterModalOpened] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [checkedRows, setCheckedRows] = useState<number[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [groundStaionData, setGroundStaionData] = useState<any[]>([]);
  const [modalData, setModalData] = useState<GroundStaionDetailData | null>(null);

  useEffect(() => {
    getGroundStation();
  }, []);

  const getGroundStation = async () => {
    const data = await fetchGroundStationList();
    const groundStaionGridData = data.map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        city: item.city,
        latitudeDegrees: item.latitudeDegrees,
        longitudeDegrees: item.longitudeDegrees,
        altitudeMeters: `${item.altitudeMeters} km`,
        providerName: item.providerName,
        statusName: item.statusName
      };
    });
    setGroundStaionData(groundStaionGridData);
  };

  function onDelete() {
    alert('Delete selected rows?');
  }

  function onAdd() {
    setIsRegisterModalOpened(true);
  }
  function onClickDeleteInDetailModal() {
    const data = cloneDeep(modalData);
    setModalData(null);
  }

  async function onClickDetail(data: any) {
    const resData = await fetchGroundStationDetail(data.id);
    const temp: GroundStaionDetailData = {
      id: (resData as any).id,
      name: resData.name,
      city: resData.city,
      altitude: resData.altitudeMeters,
      latitude: resData.latitudeDegrees,
      longitude: resData.longitudeDegrees,
      provider: resData.providerName,
      registeredAt: (resData as any).registeredAt,
      antennaVelocity: (resData as any).antennaVelocity,
      pointingAccuracy: (resData as any).pointingAccuracy,
      antennaDiameter: (resData as any).antennaDiameter,
      frequency: (resData as any).frequency,
      statusId: (resData as any).statusId,
      statusName: (resData as any).statusName,
      gtValue: (resData as any).gtValue,
      createdDate: (resData as any).createdDate,
      updatedDate: (resData as any).updatedDate
    };
    setModalData(temp);
  }

  return (
    <div className="flex h-full w-full flex-col">
      <DescriptionBar
        className="md:px-6"
        title={t('manageGroundStation.pageTitle')}
        description={t('manageGroundStation.description')}
      />
      <div className="flex flex-row items-center justify-between p-4">
        <SearchBar
          className="w-60"
          value={searchValue}
          setValue={setSearchValue}
          placeholder={t('manageGroundStation.searchPlaceholder')}
        />
        <div className="flex flex-row gap-2">
          <Button
            className="h-8"
            type="blue"
            text={t('manageGroundStation.addButton')}
            onClick={onAdd}
            icon={<PlusOutlineIcon className="[&_path]:stroke-white" />}
          />
        </div>
      </div>
      <Grid
        gridColumns={groundStationGridColumns}
        gridData={groundStaionData}
        searchValue={searchValue}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        options={{
          useFilter: false,
          useSearch: {
            use: true,
            searchKeys: ['name', 'city', 'latitude', 'longitude', 'altitude', 'provider']
          },
          useCheckbox: false,
          useSort: {
            use: true,
            sortKeys: ['name', 'city', 'latitude', 'longitude', 'altitude', 'provider', 'status']
          },
          customCell: {
            viewDetails: (_, row, index) => (
              <Button
                text={t('manageGroundStation.viewDetailsButton')}
                type="secondary"
                size="small"
                onClick={() => onClickDetail(row as GroundStaionGridData)}
              />
            )
          }
        }}
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
      />
      <GroundStationModal
        data={modalData}
        setData={setModalData}
        onDelete={onClickDeleteInDetailModal}
        onGroundStaionUpdated={getGroundStation}
      />
      <RegisterModal
        isOpened={isRegisterModalOpened}
        setIsOpened={setIsRegisterModalOpened}
        onGroundStaionUpdated={getGroundStation}
      />
    </div>
  );
};

export default ManageGroundStation;